import { SVGProps, forwardRef } from "react";
import classNames from "classnames";
import styles from "./Spinner.module.scss";

export type SpinnerProps = {
	/** Diameter (px number or any CSS length). Defaults to 1em so it scales with the text. */
	size?: number | string;
	/** Accessible label. Without it, the spinner is hidden from assistive tech. */
	label?: string;
	className?: string;
} & Omit<SVGProps<SVGSVGElement>, "width" | "height">;

/**
 * Animated loading spinner. Inherits the current text
 * color through `currentColor` and scales with the font size unless `size` is set.
 */
export const Spinner = forwardRef<SVGSVGElement, SpinnerProps>(
	({ size = "1em", label, className, ...rest }, ref) => (
		<svg
			ref={ref}
			className={classNames(styles.spinner, className)}
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
			role={label ? "status" : undefined}
			aria-label={label}
			aria-hidden={label ? undefined : true}
			{...rest}
		>
			<path d="M21 12a9 9 0 1 1-6.219-8.56" />
		</svg>
	)
);

Spinner.displayName = "Spinner";

export default Spinner;
